/** Formateurs partagés par les vues d'administration (console + détail d'organisation). */

/** Octets → unité lisible (base 1024). « illimité » pour un quota absent (null). */
export function formatBytes(bytes: number | null): string {
  if (bytes === null) return 'illimité';
  if (bytes === 0) return '0 o';
  const units = ['o', 'Ko', 'Mo', 'Go', 'To', 'Po'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, i);
  return `${value >= 100 || i === 0 ? Math.round(value) : value.toFixed(1)} ${units[i]}`;
}

/** Grand nombre en notation compacte (12 300 → « 12,3 k »), pour les jetons IA. */
export function formatCompact(value: number): string {
  if (value < 1000) return String(value);
  const units = [
    { v: 1e9, s: ' G' },
    { v: 1e6, s: ' M' },
    { v: 1e3, s: ' k' },
  ];
  const unit = units.find((u) => value >= u.v);
  if (!unit) return String(value);
  const n = value / unit.v;
  return `${n >= 100 ? Math.round(n) : n.toFixed(1)}${unit.s}`;
}

/** Part du quota consommée dans `[0,1]`, ou `null` si le quota est illimité. */
export function quotaRatio(used: number, quota: number | null): number | null {
  if (quota === null || quota === 0) return null;
  return Math.min(used / quota, 1);
}
